import './bulmaInit.scss';

// helps deal with the hamburger menu in Bulma
const supportNavBurgers = () => {
  document.querySelectorAll('.navbar-burger').forEach((el) => {
    if (!(el instanceof HTMLAnchorElement)) {
      console.log(`Not an <a>: ${el.nodeName}`);
      return;
    }
    el.addEventListener('click', () => {
      const targetId = el.dataset['target'];
      if (!targetId) {
        console.log(`No dataset-target found on ${String(el)}`);
        return;
      }
      el.classList.toggle('is-active');
      const menu = document.getElementById(targetId);
      if (!menu) {
        console.log(`No target found with ID ${targetId}`);
        return;
      }
      menu.classList.toggle('is-active');
    });
  });
};

const supportDeleteButtons = () => {
  document.querySelectorAll('.notification > .delete').forEach((deleteButton) => {
    const notificationElement = deleteButton.parentNode;
    deleteButton.addEventListener('click', () => {
      const notificationParent = notificationElement?.parentNode;
      if (notificationParent) {
        notificationParent.removeChild(notificationElement);
        if (notificationParent.children.length === 0) {
          const grandparent = notificationParent.parentNode;
          if (grandparent) {
            grandparent.removeChild(notificationParent);
          }
        }
      }
    });
  });
};

const addBulmaSupport = () => {
  supportNavBurgers();
  supportDeleteButtons();
};

export const bulmaInit = (f?: () => unknown) => {
  if (document.readyState !== 'loading') {
    addBulmaSupport();
    if (f) {
      f();
    }
  } else {
    document.addEventListener('DOMContentLoaded', addBulmaSupport);
    if (f) {
      f();
    }
  }
};
